import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-secondary flex items-center text-sm lg:text-base font-basier font-medium" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg width=\"24\" height=\"25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.25 6.37l5.75 7.4v6a1 1 0 001 1h2a1 1 0 001-1v-6l5.74-7.4a1 1 0 00-.79-1.6H5.04a1 1 0 00-.79 1.6z\" fill=\"#51747D\"></path></svg><span class=\"ml-2 mr-2 whitespace-nowrap\"> Pokaż filtry </span><svg width=\"9\" height=\"6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.5 5.26l4.5-5H0l4.5 5z\" fill=\"#51747D\"></path></svg>", 3)
const _hoisted_5 = {
  key: 0,
  class: "ml-2 bg-primary px-3 py-1 rounded-lg font-basier font-bold animate-fade-in text-white border"
}

type UiFiltersTriggerProps = {
    filtersLength: number | null
}

export default /*#__PURE__*/_defineComponent({
  props: {
    filtersLength: { type: [Number, null], required: true }
  },
  setup(__props: any) {

const props = __props as {
    filtersLength: number | null
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.filtersLength && __props.filtersLength > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.filtersLength), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})